import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { concat, interval, Observable } from 'rxjs';
import { first } from 'rxjs/operators';

const UPDATE_CHECK_INTERVAL_IN_MS = 60 * 60 * 1000;

@Injectable({
  providedIn: 'root',
})
export class SwUpdateService {
  private _isReloadInProgress = false;

  public constructor(
    private readonly _applicationRef: ApplicationRef,
    private readonly _swUpdate: SwUpdate
  ) {}

  public init(): void {
    if (!this._swUpdate.isEnabled) {
      return;
    }

    this._onCheckForUpdate$().subscribe({
      next: (): void => {
        this._checkForUpdate();
      },
    });
    this._onVersionUpdates$().subscribe({
      next: (event: VersionEvent): void => {
        if (event.type === 'VERSION_READY') {
          this._activateAndReload();
        }
      },
    });
  }

  private _onCheckForUpdate$(): Observable<number | boolean> {
    const appIsStable$ = this._applicationRef.isStable.pipe(first((isStable: boolean): boolean => isStable));

    return concat(appIsStable$, interval(UPDATE_CHECK_INTERVAL_IN_MS));
  }

  private _onVersionUpdates$(): Observable<VersionEvent> {
    return this._swUpdate.versionUpdates;
  }

  private _checkForUpdate(): void {
    void this._swUpdate.checkForUpdate().catch((): void => undefined);
  }

  private _activateAndReload(): void {
    if (this._isReloadInProgress) {
      return;
    }

    this._isReloadInProgress = true;
    void this._swUpdate
      .activateUpdate()
      .then((): void => {
        document.location.reload();
      })
      .catch((): void => {
        this._isReloadInProgress = false;
      });
  }
}
